// Image galleries of news and events: open the images in a lightbox (loaded only when needed)
export async function initGallery() {
    const links = document.querySelectorAll('.gallery a[data-gallery]');
    if (!links.length) {
        return;
    }

    const [{default: GLightbox}] = await Promise.all([
        import('glightbox'),
        import('glightbox/dist/css/glightbox.min.css'),
    ]);
    GLightbox({
        selector: '.gallery a[data-gallery]',
        loop: true,
    });
}
